import { concat, orderBy } from "lodash";
import {
  getUserSuccess,
  updateContactPrefrences,
  updateSocialaccounts,
} from "./action-types";
import { initialStateUserProfile } from "./initialState";

const userProfileReducer = (
  state = initialStateUserProfile,
  action: any
): any => {
  switch (action.type) {
    case getUserSuccess: {
      const {
        user,
        secondaryEmail,
        secondaryPhoneNumber,
        addresses,
        position,
        gearType,
        fishery,
        fisheriesEngagementWay,
        tender,
        usedApps,
      } = action.payload;
      let isSkipperApp = usedApps.some(
        (item: any) => item.id === "skipper_science"
      );
      const primaryEmail = user.email
        ? {
            email: user.email,
            isVerified: true,
            isPrimary: true,
          }
        : null;

      const primaryPhoneNumber = user.phoneNumber
        ? {
            phoneNumber: user.phoneNumber,
            isVerified: true,
            isPrimary: true,
          }
        : null;

      const emails = concat(
        primaryEmail ? [{ ...primaryEmail, isPrimary: true }] : [],
        orderBy(
          secondaryEmail.map((email: any) => ({ ...email, isPrimary: false })),
          [(email) => !email.isPrimary, (email) => !email.isVerified]
        )
      );
      const phoneNumbers = concat(
        primaryPhoneNumber ? [{ ...primaryPhoneNumber, isPrimary: true }] : [],
        orderBy(
          secondaryPhoneNumber.map((phoneNumber: any) => ({
            ...phoneNumber,
            isPrimary: false,
          })),
          [
            (phoneNumber) => !phoneNumber.isPrimary,
            (phoneNumber) => !phoneNumber.isVerified,
          ]
        )
      );

      return {
        ...action.payload,
        addresses: orderBy(
          addresses,
          ["isPrimary", "verified"],
          ["desc", "desc"]
        ),

        secondaryEmail: emails,
        secondaryPhoneNumber: phoneNumbers,

        ...(isSkipperApp && {
          position: updateArray(position),
          gearType: updateArray(gearType),
          fishery: updateArray(fishery),
          fisheriesEngagementWay: updateArray(fisheriesEngagementWay),
          tender: updateArray(tender),
        }),
      };
    }
    case updateContactPrefrences: {
      const profile = { ...state, contactPreference: action.payload };
      return profile;
    }
    case updateSocialaccounts: {
      const userProfile = { ...state, socialAccounts: action.payload };
      return userProfile;
    }

    case "RESET_USER_DATA":
      return initialStateUserProfile;
    default:
      return state;
  }
};

export default userProfileReducer;

function updateArray(items: string[]) {
  return items.map((item) =>
    typeof item === "string" ? { label: item, value: item } : item
  );
}
